import { createFileRoute } from "@tanstack/react-router"
import { ClientHeader } from "@/components/client-header"
import { ClientTabNavigation } from "@/components/client-tab-navigation"
import { Page } from "@/components/page"
import { EstateNextStepsReport } from "@/components/reports/nextSteps"
import { SidebarTrigger } from "@/components/ui/sidebar"

export const Route = createFileRoute(
  "/_authed/_professional/professional/reports/next-steps/$estateId",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { estateId } = Route.useParams()

  return (
    <Page
      showMobileNavigation={false}
      headerSlot={
        <ClientHeader
          estateId={estateId}
          mobileNavigationSlot={
            <SidebarTrigger className="size-10 shrink-0 md:hidden" aria-label="Open navigation" />
          }
        />
      }
      tabSlot={<ClientTabNavigation estateId={estateId} />}
    >
      <EstateNextStepsReport estateId={estateId} />
    </Page>
  )
}
